export class AssignAddressToNewBuildingDTO {
  oldBuildingId: string;
  addressId: string;

  constructor(dto: { oldBuildingId?: string; addressId?: string }) {
    this.oldBuildingId = dto.oldBuildingId;
    this.addressId = dto.addressId;
  }
}
